// framework/client/core/ClientControl.js

import { ComponentBase } from "./ComponentBase.js";

export class ClientControl extends ComponentBase {
    constructor(appClient) {
        super({ appClient });
        this.commandHandlers = {
            'navigate': this.handleNavigate.bind(this),
            'switch-copilot-context': this.handleSwitchCopilotContext.bind(this),
            'client-event': this.handleClientEvent.bind(this),
            // Add more command handlers here
        };
    }

    async initialize() {
        this.log.info("Initializing ClientControl");
        this.appClient.events.server.on("client-control-event", (eventPayload) => {
            this.handleClientControlEvent(eventPayload);
        });
    }

    async handleClientControlEvent(eventPayload) {
        const { command, args } = eventPayload;

        if (!command) {
            this.log.warn("Received client-control-event without command.");
            return;
        }

        const handler = this.commandHandlers[command];
        if (handler) {
            try {
                // Parse args as JSON if it's a string
                const parsedArgs = typeof args === 'string' ? JSON.parse(args) : args;
                await handler(parsedArgs);
            } catch (error) {
                this.log.error(`Error executing command '${command}':`, error);
            }
        } else {
            this.log.warn(`Unknown client control command: ${command}`);
        }
    }

    async handleNavigate(args) {
        const { routePath } = args;
        if (!routePath) {
            this.log.warn("Navigate command received without routePath.");
            return;
        }
        this.log.info(`Navigating to route: ${routePath}`);
        this.appClient.layoutEngine.navigate(routePath);
    }

    async handleSwitchCopilotContext(args) {
        const { newAgentName, contextId } = args;
        if (!newAgentName) {
            this.log.warn("switch-copilot-context command received without newAgentName.");
            return;
        }
        this.log.info(`Switching AiCoPilot context to agent: ${newAgentName}, contextId: ${contextId}`);
        this.appClient.events.fireLocal('ai-copilot-context-switched', { newAgentName, contextId });
    }

    async handleClientEvent(args) {
        const { eventName, eventData } = args;
        if (!eventName) {
            this.log.warn("client-event command received without eventName.");
            return;
        }
        this.log.info(`Emitting client event: ${eventName}, data:`, eventData);
        this.appClient.events.fireLocal(eventName, eventData);
    }
}